import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { RegisterComponent } from "./register/register.component";
import { DemandCodeComponent } from "./login/demand-code/demand-code.component";
import { ChangePasswordComponent } from "./login/change-password/change-password.component";
import { UserActivationComponent } from "./register/user-activation/user-activation.component";
import { ForgottenPasswordComponent } from "./login/forgotten-password/forgotten-password.component";
import { RegistrationConfirmComponent } from "./register/registration-confirm/registration-confirm.component";
import { MainComponent } from "../main/main.component";
import { AuthGuardService } from "src/app/services/guards/auth-guard.service";

const AccRoutingModule: Routes = [
  { path: "login", component: LoginComponent },
  { path: "register", component: RegisterComponent },
  { path: "register/:name", component: RegisterComponent },
  { path: "demandCode", component: DemandCodeComponent },
  { path: "changePass", component: ChangePasswordComponent },
  { path: "userActivation", component: UserActivationComponent },
  { path: "forgottenPass", component: ForgottenPasswordComponent },
  { path: "registerConfirmation", component: RegistrationConfirmComponent },
  { path: "registerConfirmation/:name", component: RegistrationConfirmComponent },
  { path: "student", component: MainComponent, canActivate: [AuthGuardService] }
];

@NgModule({
  imports: [RouterModule.forChild(AccRoutingModule)],
  exports: [RouterModule]
})
export class accountRouteingModule {}
